/** Shared hex ⇄ RGB helpers for gradient/title-colour maths. */

export const hexToRgb = (hex: string): { r: number; g: number; b: number } | null => {
  const m = hex.trim().match(/^#?([a-fA-F0-9]{6})$/)
  if (!m) return null
  const n = parseInt(m[1], 16)
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 }
}

const clamp = (v: number) => Math.max(0, Math.min(255, Math.round(v)))

export const rgbToHex = (r: number, g: number, b: number): string =>
  '#' + [r, g, b].map((c) => clamp(c).toString(16).padStart(2, '0')).join('')
